var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type)?_c('Icon',{attrs:{"icon":_vm.type === 'group' ? 'building' : 'user'}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }